import React from 'react';

function DiscountIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 4.00016L3 1.3335H11L13 4.00016M1 4.00016V13.3335C1 13.6871 1.14048 14.0263 1.39052 14.2763C1.64057 14.5264 1.97971 14.6668 2.33333 14.6668H11.6667C12.0203 14.6668 12.3594 14.5264 12.6095 14.2763C12.8595 14.0263 13 13.6871 13 13.3335V4.00016M1 4.00016H13M9.66667 6.66683C9.66667 7.37407 9.38571 8.05235 8.88562 8.55245C8.38552 9.05254 7.70724 9.3335 7 9.3335C6.29276 9.3335 5.61448 9.05254 5.11438 8.55245C4.61428 8.05235 4.33333 7.37407 4.33333 6.66683" stroke="#2C2C2C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default DiscountIcon;
